import { render, staticRenderFns } from "./sites-on-hold.vue?vue&type=template&id=3936a0c6&"
import script from "./sites-on-hold.vue?vue&type=script&lang=js&"
export * from "./sites-on-hold.vue?vue&type=script&lang=js&"
import style0 from "./sites-on-hold.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports